import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    AGENT_RESIDUALS_TOTAL_LOAD,
    AGENT_RESIDUALS_TOTAL_SUCCESS,
    AGENT_RESIDUALS_TOTAL_FAILURE,
    AGENT_RESIDUALS_LOAD,
    AGENT_RESIDUALS_SUCCESS,
    AGENT_RESIDUALS_FAILURE
} from './agentResidualsActions';

export default function reducer(state = {}, action = {}) {
    let newState;
    switch (action.type) {
        case AGENT_RESIDUALS_TOTAL_LOAD:
            newState = {
                ...state,
                agentResidualsTotalLoading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case AGENT_RESIDUALS_TOTAL_SUCCESS:
            newState = {
                ...state,
                agentResidualsTotalLoading: false,
                agentResidualsTotal: action.summaryResults
            };

            return _.isEqual(state, newState) ? state : newState;

        case AGENT_RESIDUALS_TOTAL_FAILURE:
            newState = {
                ...state,
                agentResidualsTotalError: action.error,
                agentResidualsTotalLoading: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case TABLE_UNMOUNT:
            newState = {
                ...state,
                agentResiduals: [],
                agentResidualsTotal: {},
                agentResidualsTotalLoading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case AGENT_RESIDUALS_LOAD:
            newState = {
                ...state,
                agentResiduals: [],
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case AGENT_RESIDUALS_SUCCESS:
            newState = {
                ...state,
                agentResiduals: action.agentResiduals,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return _.isEqual(state, newState) ? state : newState;

        case AGENT_RESIDUALS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return _.isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}
export const getAgentResidualsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'agentResiduals')
);

export const getAgentResidualsTotal = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'agentResidualsTotal')
);

export const getIsAgentResidualsTotalLoading = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'agentResidualsTotalLoading')
);

export const getAgentResidualsTotalErrorMessage = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'agentResidualsTotalError')
);

export const getAgentResiduals = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'agentResiduals')
);

export const getIsAgentResidualsLoading = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'loading')
);

export const getAgentResidualsError = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'error')
);

export const getAgentResidualsErrorMessage = createSelector(
    getAgentResidualsError,
    (error) => _.get(error, 'message')
);

export const getPages = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'pages')
);

export const getCount = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'count')
);

export const getHasMore = createSelector(
    getAgentResidualsEntity,
    (entity) => _.get(entity, 'hasMore')
);
